module.exports = __webpack_public_path__ + "static/media/carrier_header.d65fddd4.png";